export const CHIPS_TYPES = {
  default: 'default',
  outline: 'outline',
  ghost: 'ghost'
}
